let _handler = null;

export function setSourcePickerHandler(handler) {
  _handler = handler;
}

export function callSourcePickerHandler(result) {
  if (_handler) {
    _handler(result);
    _handler = null;
  }
}

export function clearSourcePickerHandler() {
  _handler = null;
}
